import { combineReducers } from 'redux-immutablejs';
import { firebaseReducer } from 'react-redux-firebase';
import { firestoreReducer } from 'redux-firestore';
import { connectRouter } from 'connected-react-router/immutable';

import reducer from '@reducers';

export default history =>
  combineReducers({
    app: reducer,
    firebase: firebaseReducer,
    firestore: firestoreReducer,
    router: connectRouter(history),
  });
